import { Injectable } from '@angular/core';
import { FileOpener } from '@capacitor-community/file-opener';
import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { AccountService } from '@timechef/features/account/state/account.service';
import { AppErrorKeys, appErrorFromKey } from '../errors/error';
import { ILogger } from '../logging';

export type FileType = 'application/pdf' | 'plain/text';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private accountService: AccountService) {}

  async getBlobAndOpenIt(data: string, fileName: string, fileType: FileType, logger?: ILogger) {
    const blob = new Blob([data], { type: fileType });
    if (Capacitor.isNativePlatform()) {
      await this.openInNativeApp(blob, fileName, logger);
    } else {
      this.openInNavigator(blob, fileName);
    }
  }

  private openInNavigator(blob: Blob, fileName: string) {
    const fileURL = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  }

  private openInNativeApp(data: Blob, fileName: string, logger?: ILogger): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = async () => {
        const base64data = reader.result;
        try {
          await Filesystem.writeFile({
            path: fileName,
            data: base64data as string,
            directory: Directory.Cache,
          });

          const uriResult = await Filesystem.getUri({
            directory: Directory.Cache,
            path: fileName,
          });

          await FileOpener.open({
            filePath: uriResult.uri,
            contentType: 'application/pdf',
          }).catch((e) => reject(appErrorFromKey(e.code === '8' ? AppErrorKeys.NoActivityFoundForFileOpen : AppErrorKeys.AnErrorOccured)));

          this.accountService.updateStatusBar();

          resolve(true);
        } catch (e) {
          reject(e);
          logger?.error('Unable to write file', e);
        }
      };
    });
  }
}
